/**
 * Header component.
 * @module components/theme/Header/Header
 */

/**
 * Customizations:
 * - add HeaderTop
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  HeaderTop,
  HeaderMain,
  LeadImage,
  BannerNotice,
} from '@redturtle/iovisit-theme/components/layout/';

/**
 * Header component class.
 * @class Header
 * @extends Component
 */
class Header extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    pathname: PropTypes.string.isRequired,
  };

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    return (
      <>
        <div className="iv--header-wrapper" role="banner">
          <HeaderTop />
          <HeaderMain pathname={this.props.pathname} />
        </div>
        <LeadImage />
        <BannerNotice />
      </>
    );
  }
}

export default Header;
